import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { JourneyRoute } from '@cash-web/shared-journey-data-access-context'

export const flowJourneyRoutes = [
  {
    id: 'journey-get-flow-initiation-data',
    trackingName: 'Journey Get Flow Initiation Data',
    path: 'dl/flow/:initiationData',
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlow')).JourneyGetFlow,
    }),
  },
  {
    id: 'journey-get-flow-change-card-design',
    trackingName: 'Journey Get Flow Change Card Design',
    path: `dl/flow/type/${FlowType.CHANGE_CARD_DESIGN}`,
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlowChangeCardDesign')).JourneyGetFlowChangeCardDesign,
    }),
    modalVariant: 'fullscreen',
  },
  {
    id: 'journey-get-flow-request-physical-card',
    trackingName: 'Journey Get Flow Request Physical Card',
    path: `dl/flow/type/${FlowType.REQUEST_PHYSICAL_CARD}`,
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlowRequestPhysicalCard')).JourneyGetFlowRequestPhysicalCard,
    }),
    modalVariant: 'fullscreen',
  },
  {
    id: 'journey-get-flow-type',
    trackingName: 'Journey Get Flow Type',

    path: 'dl/flow/type/:flowType',
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlow')).JourneyGetFlow,
    }),
  },
  {
    id: 'journey-complete-scenario-report-lost-card',
    trackingName: 'Journey Complete Scenario Report Lost Card',
    path: `dl/scenario/${ClientScenario.REPORT_LOST_CARD}`,
    lazy: async () => ({
      Component: (await import('../components/JourneyCompleteScenarioReportLostCard'))
        .JourneyCompleteScenarioReportLostCard,
    }),
    modalVariant: 'fullscreen',
  },
  {
    id: 'journey-complete-scenario-with-flow-token',
    trackingName: 'Journey Complete Scenario with Flow Token',
    path: 'dl/scenario/complete/:clientScenario/:flowToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyCompleteScenario')).JourneyCompleteScenario,
    }),
  },
  {
    id: 'journey-complete-scenario',
    trackingName: 'Journey Complete Scenario',
    path: 'dl/scenario/:clientScenario',
    lazy: async () => ({
      Component: (await import('../components/JourneyCompleteScenario')).JourneyCompleteScenario,
    }),
  },
  {
    id: 'journey-get-cash-app-card',
    trackingName: 'Journey Get Cash App Card',
    path: 'dl/view/request-cash-card/style-picker',
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlowRequestPhysicalCard')).JourneyGetFlowRequestPhysicalCard,
    }),
    modalVariant: 'fullscreen',
  },
] as const satisfies JourneyRoute[]
